module.exports = __webpack_public_path__ + "static/media/music.e0d5ca6e.svg";